import api from './api'

export default {
  getAll(params = {}) {
    return api.get('/admin/ai-prompts', { params })
  },

  getOne(id) {
    return api.get(`/admin/ai-prompts/${id}`)
  },

  create(payload) {
    return api.post('/admin/ai-prompts', payload)
  },

  update(id, payload) {
    return api.patch(`/admin/ai-prompts/${id}`, payload)
  },

  publish(id) {
    return api.post(`/admin/ai-prompts/${id}/publish`)
  },

  archive(id) {
    return api.post(`/admin/ai-prompts/${id}/archive`)
  },

  getVersions(id) {
    return api.get(`/admin/ai-prompts/${id}/versions`)
  },
}
